import { Box, Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  item: React.ReactNode
  to: string
}

const CardLinked = ({ item, to }: Props) => {
  return (
    <Box
      key={i18n.t('procurement.purchase_orders.detail.purchase_request.requested_by')}
      paddingX="s24"
      paddingY="s16"
      gap="s8"
      borderRadius={{ all: 'abs008' }}
      alignItems="center"
      justifyContent="spaceBetween"
      flexDirection="row"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
    >
      {item}
      <Button.Router type="secondary" to={to} iconName="arrow-right" />
    </Box>
  )
}

export default CardLinked
